import { render, staticRenderFns } from "./regionalScreen.vue?vue&type=template&id=27ce3711&"
import script from "./regionalScreen.vue?vue&type=script&lang=js&"
export * from "./regionalScreen.vue?vue&type=script&lang=js&"
import style0 from "./regionalScreen.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-gov-report/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27ce3711')) {
      api.createRecord('27ce3711', component.options)
    } else {
      api.reload('27ce3711', component.options)
    }
    module.hot.accept("./regionalScreen.vue?vue&type=template&id=27ce3711&", function () {
      api.rerender('27ce3711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/person/regionalScreen.vue"
export default component.exports